import * as Yup from "yup"

const validationSchema = Yup.object().shape({
  message: Yup.string().trim().required('Votre message ne doit pas être vide'),
  sujet: Yup.string().required('Vous devez choisir un sujet')
})


export default validationSchema
